import calculatePriceValues, { type Price } from '@spa/lib/getPriceValues';
import strikeRulesFactory, { StrikePriceInfo } from './price-strike-rules';

export interface IsProductOnSalePrices {
  readonly currentPrice: Price;
  readonly recommendedRetailPrice: Price | null;
  readonly campaignPrice: Price | null;
  readonly strikePrice: Price | null;
  readonly lowestVariantPrice?: Price | null;
}

export function computeIsProductOnSale(
  country: string,
  pricesIncludeTax: boolean,
  prices: IsProductOnSalePrices
): boolean {
  const {
    currentPriceValue,
    recommendedRetailPriceValue,
    campaignPriceValue,
    strikePriceValue,
    lowestVariantPriceValue
  } = calculatePriceValues(pricesIncludeTax, {
    currentPrice: prices.currentPrice,
    recommendedRetailPrice: prices.recommendedRetailPrice,
    campaignPrice: prices.campaignPrice,
    strikePrice: prices.strikePrice,
    lowestVariantPrice: prices.lowestVariantPrice ?? null
  });

  const strikeRules = strikeRulesFactory(country, {
    currentPriceValue,
    recommendedRetailPriceValue,
    campaignPriceValue,
    strikePriceValue
  });
  const resolvedStrikePriceInfo: StrikePriceInfo | undefined = strikeRules.findStrikePriceInfo();
  const strikePriceInfo: StrikePriceInfo | undefined = !lowestVariantPriceValue
    ? resolvedStrikePriceInfo
    : undefined;
  return Boolean(strikePriceInfo) || Boolean(lowestVariantPriceValue && resolvedStrikePriceInfo);
}
